<template>
  <div class="users container">

    <!-- ------------------------------- Modal: User Profile ------------------------------------------ -->

	<div>
		<CModal title="User Profile" color="info" :show.sync="profileModal" size="lg">	
			<div slot="header">
				<h5>{{user.name}}, Department: {{user.deptName}}</h5>
			</div>	  
			<div slot="footer">
				<button class="btn btn-info" v-on:click.prevent="serverCall('saveUserProfile')">Save</button>
				<button class="btn btn-info ml-2" v-on:click.prevent="profileModal=false">Close</button>
			</div>

			<form>

				<div class="form-group row">
					<label for="userId" class="col-sm-2 col-form-label text-right text-right">User ID</label>
					<div class="col-sm-4">
						<input type="text" id="userId" class="form-control"
								v-model="user.userId">
					</div>
					<label for="activeFlag" class="col-sm-2 col-form-label text-right text-right">Active?</label>
					<div class="col-sm-4">
						<select class="form-control" v-model="user.activeFlag">
							<option value=true>Yes</option>
							<option value=false>No</option>
						</select>
					</div>
				</div>

				<div class="form-group row">
					<label for="name" class="col-sm-2 col-form-label text-right">Name</label>
					<div class="col-sm-10">
						<input type="text" id="name" class="form-control" 
								v-model="user.name" required="">
					</div>
				</div>


				<div class="form-group row">
					<label for="dept" class="col-sm-2 col-form-label text-right">Department</label>
					<div class="col-sm-10">
						<select class="form-control" v-model="deptSelected">
							<option v-for="dept in deptList" v-bind:value="{ id: dept.id, name: dept.name }">
								{{ dept.name }}
							</option>
						</select>
					</div>
				</div>

				<div class="form-group row">
					<label for="phone" class="col-sm-2 col-form-label text-right">Phone</label>
					<div class="col-sm-4">
						<input type="text" id="phone" class="form-control" 
								v-model="user.phone" required="">
					</div>
					<label for="imei" class="col-sm-2 col-form-label text-right">Phone IMEI</label>
					<div class="col-sm-4">
						<input type="text" id="imei" class="form-control" 
								v-model="user.imei" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="profilePic" class="col-sm-2 col-form-label text-right">Profile Pic</label>
					<div class="col-sm-4">
						<input type="file" id="profilePic" ref="profilePic"
						@change="previewFiles">
					</div>
					<label for="gender" class="col-sm-2 col-form-label text-right">Gender</label>
					<div class="col-sm-4">
						<select class="form-control" v-model="user.gender">
							<option value="M">Male</option>
							<option value="F">Female</option>
						</select>
					</div>
				</div>

				<div class="form-group row">
					<label for="address" class="col-sm-2 col-form-label text-right">Address</label>
					<div class="col-sm-10">
						<input type="text" id="address" class="form-control" 
								v-model="user.address" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="joiningDate" class="col-sm-2 col-form-label text-right">Joining Date</label>
					<div class="col-sm-4">
						<datepicker v-model="user.joiningDate" name="joiningDate" format="MMM dd yyyy">
						</datepicker>
					</div>
					<label for="leavingDate" class="col-sm-2 col-form-label text-right">Leaving Date</label>
					<div class="col-sm-4">
						<datepicker v-model="user.leavingDate" name="leavingDate" format="MMM dd yyyy">
						</datepicker>
					</div>
				</div>

				<div class="form-group row">
					<label for="IFSC" class="col-sm-2 col-form-label text-right">IFSC</label>
					<div class="col-sm-4">
						<input type="text" id="IFSC" class="form-control" 
								v-model="user.IFSC" required="">
					</div>
					<label for="BankAccount" class="col-sm-2 col-form-label text-right">Bank Account</label>
					<div class="col-sm-4">
						<input type="text" id="BankAccount" class="form-control" 
								v-model="user.BankAccount" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="Bank" class="col-sm-2 col-form-label text-right">Bank Name</label>
					<div class="col-sm-10">
						<input type="text" id="Bank" class="form-control" 
								v-model="user.Bank" required="">
					</div>
				</div>

				<p class="text-danger" align="left">{{userAlert}}</p>
			</form>

		</CModal>
	</div>

    <!-- ---------------------------------------  User List -------------------------------------------------- -->

	<div align="center">
		<label for="loadingMsg" v-if="loading">{{loadingMsg}}</label>
		<scale-loader :loading="loading"></scale-loader>
	</div>

	<vue-good-table ref="usersTable" :columns="colUsers" :rows="rowUsers" 
							:pagination-options="pagination_options" :lineNumbers="true"
							@on-row-click="rowChanged" 
							:selectOptions="{
									enabled: true,
									selectOnCheckboxOnly: false, 
									selectAllByGroup: false,
							}">
			<div slot="table-actions">
				<CButton  class="ml-2 mr-3" color="primary" v-on:click.prevent="openNewUserProfile()">
					Add
				</CButton>
			</div>
			<div slot="selected-row-actions">
				<CButton color="info" v-on:click.prevent="openUserProfile()">
					Modify
				</CButton>
				<CButton class="ml-2" color="info" v-on:click.prevent="serverCall('deleteUser')">
					Delete
				</CButton>
			</div>
	</vue-good-table>

	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import Datepicker from 'vuejs-datepicker'
import ScaleLoader from "@/views/utils/ScaleLoader"
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'users',

    components: {
		ScaleLoader,
		Datepicker,
		},
		
	data () {
		return {
			alert: '',
			userAlert: '',
            loading: false,
			loadingMsg: null,

			profileModal: false,
			salaryModal: false,

			deptSelected: {'id': '', 'name': ''},

			profileBucket: '',

			deptList: [],

			users: [],
			userReportHtml: "",

			user: {
					userDocId: '',
					activeFlag: '',
					userId: '',
					name: '',
					phone: '',
					imei: '',
					deptId: '',
					deptName: '',
					address: '',
					profilePic: '',
					gender: 'M',
					joiningdate: '',
					leavingDate: '',
					IFSC: '',
					Bank: '',
					BankAccount: '',
			},

			addlLoan: 0,
			onetimeRepay: 0,

			addFlag: false,

            pagination_options: {
                enabled: true,
                mode: 'records',
                perPage: 10,
                position: 'top',
                perPageDropdown: [5, 10, 15, 20],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            },

			colUsers: [
					{
							label: 'Name',
							field: 'name',
							html: false,
							filterOptions: {enabled: true,},
					},
					{
							label: 'User ID',
							field: 'userId',
							html: false,
							filterOptions: {enabled: false,},
					},
					{
							label: 'Department',
							field: 'deptName',
							html: false,
							filterOptions: {enabled: true,},
					},
					{
							label: 'Active?',
							field: 'activeFlagDisplay',
							html: false,
					},
					{
							label: 'Profile Picture',
							field: 'profilePicUrl',
							html: true
					},
					{
							label: 'Phone',
							field: 'phone',
							html: false
					},
					{
							label: 'Joining Date',
							field: 'joiningDate',
							html: false,
					},
			],

			rowUsers: [],
			curRowSelected: null,

		}
	},

	computed: {
	},

	mounted(){
		this.serverCall("getUsers")
	},

	methods: {
        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getUsers":
								self.getUsers(idToken, org)
								break;
							case "saveUserProfile":
								self.saveUserProfile(idToken, org)
								break;
							case "deleteUser":
								self.deleteUser(idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})

		},	

		previewFiles()
		{
			this.user.profilePic = this.$refs.profilePic.files[0]
		},

        // Fetch users for the given org
        getUsers(authToken, org) {
            var self = this
			self.alert = null

			// Set loading message
			self.loading = true
			self.loadingMsg = "Fetching Users..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/GetUsers/',
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						self.deptList = response.data.deptList
						self.rowUsers =  response.data.userList
						self.userReportHtml = response.data.userReportHtml
					}
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
				.catch(function (error) {
					console.log(String(error))
					self.alert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row
		},

		// Open details for existing user
		openUserProfile(){
            var self = this
			self.userAlert = null

            // Check if User is selected
			if (self.curRowSelected==null){
				self.alert = "User not selected."
				return
			}

			// Initialize user object
			self.user.userDocId = self.curRowSelected.userDocId
			self.user.userId =  self.curRowSelected.userId
			self.user.name = self.curRowSelected.name
			self.user.phone = self.curRowSelected.phone
			self.deptSelected.id = self.curRowSelected.deptId
			self.deptSelected.name = self.curRowSelected.deptName		
			self.user.imei = self.curRowSelected.imei
			self.user.address = self.curRowSelected.address
			self.user.activeFlag = self.curRowSelected.activeFlag
			self.user.profilePicSaved = self.curRowSelected.profilePicSaved
			self.user.gender = self.curRowSelected.gender
			self.user.profilePicUrl = self.curRowSelected.profilePicUrl
			self.user.joiningDate = self.curRowSelected.joiningDate
			self.user.leavingDate = self.curRowSelected.leavingDate
			self.user.IFSC = self.curRowSelected.IFSC
			self.user.Bank = self.curRowSelected.Bank
			self.user.BankAccount = self.curRowSelected.BankAccount

			//https://storage.cloud.google.com/tk3-profile-1/0jbFlZHMyfsJCtyTktid

			// Show modal with user values
			self.profileModal = true
		},

		// New user
		openNewUserProfile(){
            var self = this
			self.userAlert = null

			// Initialize user object
			self.user.userDocId = ''
			self.user.userId =  ''
			self.user.name = ''
			self.user.phone = ''
			self.user.deptId = ''
			self.user.deptName = ''
			self.user.imei = ''
			self.user.address = ''
			self.user.activeFlag = true
			self.user.profilePicSaved = 'false'
			self.user.gender = "M"
			self.user.joiningDate = new Date()
			self.user.leavingDate = new Date()
			self.user.IFSC = ''
			self.user.Bank = ''
			self.user.BankAccount = ''

			// Show modal with user values
			//$('#userProfileModal').modal('show')
			this.profileModal = true
		},

		// Save user changes - for new as well as existing users
        saveUserProfile(authToken, org) {
            var self = this
            this.userAlert = ""

            if (!self.user.name) {
                self.userAlert= 'User name not specified.'
                return
            }
            if (!self.user.userId) {
                self.userAlert = 'User ID not specified.'
                return
            }

			var formData = new FormData();
			formData.append("userDocId", self.user.userDocId);
			formData.append("userId", self.user.userId);
			formData.append("name", self.user.name);
			formData.append("phone", self.user.phone);
			formData.append("imei", self.user.imei);
			formData.append("deptId", self.deptSelected.id);
			formData.append("deptName", self.deptSelected.name);
			formData.append("address", self.user.address);
			formData.append("activeFlag", self.user.activeFlag);
			formData.append("profilePic", self.user.profilePic);
			formData.append("gender", self.user.gender);
			formData.append("joiningDate", self.user.joiningDate);
			formData.append("leavingDate", self.user.leavingDate);
			formData.append("IFSC", self.user.IFSC);
			formData.append("Bank", self.user.Bank);
			formData.append("BankAccount", self.user.BankAccount);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/saveUserProfile/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != '') {
						self.userAlert = response.data.err
					}
					else {
						// Refresh user list on the screen
						self.serverCall("getUsers")						
						//$('#userProfileModal').modal('hide')
						self.profileModal = false
					}
				})
				.catch(function (error) {
					self.userAlert = String(error)
				})
		},

		// Delete User
		deleteUser(authToken, org){
			var self = this

            // Check if User is selected
			if (self.curRowSelected==null){
				self.alert = "User not selected."
				return
			}

			// Initialize user object
			var formData = new FormData();
			formData.append("userDocId", self.curRowSelected.userDocId);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/DeleteUser/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Refresh user list on the screen
						self.serverCall("getUsers")	
					}				
				})
				.catch(function (error) {
					self.userAlert = String(error)
				})
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
